var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _ellipse, _path18, _mask, _g, _rect, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 455,
    viewBox: "0 0 328 455",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164 152.984L0.499512 0V142.985L142.599 191.18",
    fill: "#FFEED7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.50049 292.614H102.472V192.615L-1.50049 180.461V292.614Z",
    fill: "#FFDBA9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8729 139.068L98.1943 163.324L92.3747 163.576L91.8108 177.59L71.5379 176.134L69.6601 186.71C69.6601 186.71 65.0504 197.012 52.9731 196.366C43.2774 195.846 38.0162 183.02 38.0162 183.02L44.3887 136.725C45.7903 126.554 54.9769 119.312 65.1927 120.325L104.277 124.195C104.277 124.195 105.925 135.395 92.8729 139.068Z",
    fill: "#1BD697"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8721 139.068C106.247 136.808 104.281 124.195 104.281 124.195L65.1974 120.325C54.9815 119.312 45.7895 126.554 44.3934 136.725L41.5739 157.204C46.7311 157.215 51.2806 153.854 52.8299 148.933C54.4121 143.897 56.5801 138.22 58.5839 137.048C65.0222 133.271 86.6966 140.108 92.8721 139.068Z",
    fill: "#3C4852"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5227 132.035L63.9386 144.193C63.9386 144.193 69.4024 144.735 71.9701 141.128C74.5377 137.52 75.0742 132.057 75.0742 132.057L66.5227 132.035Z",
    fill: "#3C4852"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7227 153.315C79.0446 153.315 77.6843 151.955 77.6843 150.277C77.6843 148.599 79.0446 147.238 80.7227 147.238C82.4009 147.238 83.7612 148.599 83.7612 150.277C83.7612 151.955 82.4009 153.315 80.7227 153.315Z",
    fill: "#3C4852"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.474 192.077L150.603 218.547L150.044 183.254L161.796 167.262L180.824 257.149L102.474 239.155V192.077Z",
    fill: "#FFDBA9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M163.308 151.486L169.656 155.781L142.345 196.129L135.998 191.833L163.308 151.486Z",
    fill: "#2D81F7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M162.448 167.368C161.829 159.872 155.126 160.302 155.126 160.302C155.126 160.302 148.409 162.739 147.929 170.667C147.929 170.667 150.309 177.49 149.167 186.064",
    fill: "#FFAD3B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M128.026 433.004L149.04 454.016L218 417.241H128.026V433.004Z",
    fill: "#C0DBFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M128.026 401.476L149.04 380.464L218 417.238H128.026V401.476Z",
    fill: "#2D81F7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M128.027 417.238V438.25H112.263V417.238H128.027Z",
    fill: "#C0DBFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M128.027 396.227V417.238H112.263V396.227H128.027Z",
    fill: "#2D81F7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M146.409 417.242C146.409 413.978 149.055 411.332 152.32 411.332C155.584 411.332 158.23 413.978 158.23 417.242C158.23 420.506 155.584 423.152 152.32 423.152C149.055 423.152 146.409 420.506 146.409 417.242Z",
    fill: "#FDF7EA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M111.988 399.374V435.746L-131 435.746V399.374L111.988 399.374Z",
    fill: "#C0DBFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-1 292.469H226V366.461H-1V292.469Z",
    fill: "#A6F1D8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M225.914 366.59C246.66 366.59 263.473 349.999 263.473 329.529C263.473 309.059 246.66 292.469 225.914 292.469",
    fill: "#FFA1A1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 12.3548,
    ry: 12.3535,
    transform: "matrix(-1 0 0 1 225.415 329.947)",
    fill: "#08BD80"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M131 80.4913C118.297 80.4913 108 70.4188 108 57.9937C108 45.5686 118.297 35.4961 131 35.4961C143.702 35.4961 154 45.5686 154 57.9937C154 70.4188 143.702 80.4913 131 80.4913Z",
    fill: "#FFAD3B"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 248,
    y: 385,
    width: 80,
    height: 46
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 385.461,
    width: 79.36,
    height: 45.4618,
    rx: 20,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 287.269,
    cy: 410.673,
    rx: 20.2533,
    ry: 20.2512,
    fill: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 307.528,
    cy: 419.355,
    rx: 14.88,
    ry: 14.8784,
    fill: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 288.513,
    cy: 421.835,
    rx: 14.88,
    ry: 14.8784,
    fill: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.845,
    cy: 419.355,
    rx: 14.88,
    ry: 14.8784,
    fill: "#FFCDCD"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 281.895,
    y: 421.832,
    width: 12.4,
    height: 14.0518,
    fill: "#2D81F7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M299.258 435.883H276.938L288.098 447.455L299.258 435.883Z",
    fill: "#2D81F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoy);
export default __webpack_public_path__ + "static/media/boy.01482c3a639c7058f0ca1bff31708f06.svg";
export { ForwardRef as ReactComponent };